
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendario/[id]",
      function () {
        return require("private-next-pages/calendario/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendario/[id]"])
      });
    }
  